import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueContentPlaceholders from 'vue-content-placeholders';
import VueScrollTo from 'vue-scrollto';
import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import VueApollo from 'vue-apollo';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { loadLanguage } from '@/core/i18nUtils';
import createRouter from './router';

function prepareApollo() {
  Vue.use(VueApollo);

  const apiClient = new ApolloClient({
    uri: process.env.ICI_API_URL,
    cache: new InMemoryCache(),
    fetchOptions: {
      mode: 'cors',
    },
  });

  const buildingClient = new ApolloClient({
    uri: process.env.BUILDING_API_URL,
    cache: new InMemoryCache(),
    fetchOptions: {
      mode: 'cors',
    },
  });

  const mediaCommClient = new ApolloClient({
    uri: process.env.MEDIA_C_URL,
    cache: new InMemoryCache(),
    fetchOptions: {
      mode: 'cors',
    },
  });

  const mediaIndClient = new ApolloClient({
    uri: process.env.MEDIA_I_URL,
    cache: new InMemoryCache(),
    fetchOptions: {
      mode: 'cors',
    },
  });

  const mediaShopClient = new ApolloClient({
    uri: process.env.MEDIA_S_URL,
    cache: new InMemoryCache(),
    fetchOptions: {
      mode: 'cors',
    },
  });

  const webDataAdapterClient = new ApolloClient({
    uri: process.env.WEB_DATA_ADAPTER_URL,
    cache: new InMemoryCache(),
    fetchOptions: {
      mode: 'cors',
    },
  });

  return new VueApollo({
    clients: {
      api: apiClient,
      building: buildingClient,
      mediaC: mediaCommClient,
      mediaI: mediaIndClient,
      mediaS: mediaShopClient,
      webDataAdapter: webDataAdapterClient,
    },
    defaultClient: apiClient,
  });
}

export default (i18n) => {
  Vue.use(VueScrollTo);

  Vue.use(VueContentPlaceholders);

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.GOOGLE_MAP_API_KEY,
      v: '3',
    },
  });

  AOS.init();

  const Media = () => import('../main');

  const vue = new Vue({
    el: '#media',
    i18n,
    apolloProvider: prepareApollo(),
    router: createRouter(),
    data() {
      return {
        loadedI18n: false,
      };
    },
    render(h) {
      if (this.loadedI18n) {
        return h(Media);
      }
      return h('p', '');
    },
    async beforeCreate() {
      await loadLanguage(this, [
        'main',
      ]);

      switch (window.lang) {
        case 'english': this.$i18n.locale = 'en'; break;
        case 'gb': this.$i18n.locale = 'gb'; break;
        default: this.$i18n.locale = 'zh';
      }
      this.loadedI18n = true;
    },
  });

  return vue;
};
